import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import CommonUiIcon from 'webapp/components/common/ui-icon';

interface CommonSecurityInfoSmallComponentInterface {
	Element: HTMLDivElement;
	Args: object;
}

export default class CommonSecurityInfoSmallComponent extends Component<CommonSecurityInfoSmallComponentInterface> {
	@service('account') declare accountService: Service.Account;

	<template>
		{{#unless this.accountService.hideDataboxNotWhiteLabeledContentForNonAdmins}}
			<div class="security-info-small">
				<CommonUiIcon @name="DataboxShield" @size="lg" />
				<span>
					Your data is secure with us.
					<a
						href="https://databox.com/security-policy"
						class="link link--blue"
						target="_blank"
					>
						Read more
					</a>
					about our security policies.
				</span>
			</div>
		{{/unless}}
	</template>
}
